import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ToolProcessingEntry } from "@components/tool-card/tool-processing-card.model";
import { TranslateService } from "@ngx-translate/core";
import { ToolRequest } from "@models/toolRequests.model";
import { ToolRequestType } from "@models/enums/tool-request-type.enum";
import { ToolReturn } from "@models/tool-return.model";
import { ToolReturnTypeEnum } from "@models/enums/tool-return-type.enum";

@Component({
    selector: 'app-tool-processing-card',
    templateUrl: './tool-processing-card.component.html',
    styleUrls: ['./tool-processing-card.component.scss']
})
export class ToolProcessingCardComponent implements OnInit {

    @Input() entry: ToolProcessingEntry;
    @Output() select = new EventEmitter<any>();

    public static fromToolRequest(request: ToolRequest) {
        return new ToolProcessingEntry({
                payload: request,
                title: request.name,
                subTitle: request.status,
                iconLabel: request?.type.toString().toLowerCase(),
                icon: (() => {
                    switch (request.type as any) {
                        case "LINE":
                            return 'production';
                        case "STRAIN":
                            return 'strain';
                        case "MAINTENANCE":
                            return 'maintenance';
                        case "TICKET":
                            return 'ticket';
                        default:
                            return 'production';
                    }
                })(),
                extra: request.createdDate
            }
        );
    }

    public static fromToolReturn(returned: ToolReturn) {
        return new ToolProcessingEntry({
                payload: returned,
                title: returned?.toolRequest?.name,
                subTitle: returned.status,
                iconLabel: returned?.type ? returned?.type?.toString().toLowerCase() : ToolReturnTypeEnum.LINE.toString(),
                icon: (() => {
                    switch (returned.type as any) {
                        case "LINE":
                            return 'production';
                        case "STRAIN":
                            return 'strain';
                        case "MAINTENANCE":
                            return 'maintenance';
                        case "TICKET":
                            return 'ticket';
                        default:
                            return 'production';
                    }
                })(),
                extra: returned.createdDate
            }
        );
    }

    @HostListener('click', ['$event.target'])
    onClick() {
        this.select.emit(this.entry);
    }

    constructor(private translate: TranslateService) {
    }

    ngOnInit(): void {
    }

    get status() {
        return this.entry?.subTitle;
    }

    computeIcon() {
        return "";
    }
}
